<style>
  .row-border-top {
    border-top: 1px solid #e3e3e3;
  }
</style>

<template>

  <div
    v-if="shouldShowHeaderRows"
    class="SectionTable"
  >
<!--    <TemplateSectionToolbar :section="section"/>-->

    <!--
    <span style="display: none; position:absolute; z-index: 1; background-color: transparent; left: 200px; top: 28px;">
      <v-btn
        x-small
        color="primary"
        @click="toggleEditingSettings"
      ><v-icon x-small style="margin-right: 5px;">mdi-cog</v-icon>Edit</v-btn>
    </span>
    -->
    <TemplateSectionRow
      v-for="(row, i) in rows"
      :key="i"
      :row="row"
    />

    <div
      v-if="shouldShowSelectAllSectionResourcesBtn"
      style="position:absolute; background-color: #fff; z-index: 1; left: 10px; top: 10px;"
    >
      <v-checkbox
        label=""
        style="margin: 0; padding: 0;"
        hide-details
        class="resource-selected-checkbox"
        @click="selectAllSectionResources"
      ></v-checkbox>
    </div>

    <TemplateSectionRow emptyRow/>
  </div>

</template>


<script>

import TemplateSectionRow from '@/components/sections/TemplateSection/TemplateSectionResourceTableRow.vue';
// mixins
import Mixin from '@/mixins/mixin';
// import TemplateSectionToolbar from '@/components/sections/TemplateSectionToolbar';

export default {
  name: 'TemplateSectionHeaderRows',
  components: {
    // TemplateSectionToolbar,
    TemplateSectionRow,
  },
  mixins: [Mixin],
  data: () => ({
    scrollToNext: false,
  }),
  props: {
    section: Object,
  },
  computed: {
    shouldShowSelectAllSectionResourcesBtn() {
      return false;
      // const isEditingSection = this.$store.state.activeTemplate.isNavigatorVisible === this.section.id;
      // return isEditingSection && this.section.sectionResources && this.section.sectionResources.length;
    },
    shouldShowHeaderRows() {
      return true;
      // const shouldShow = this.section.isInitialized || this.section.isEditingSettings || this.section.isAddingResource;
      // const shouldShow = true;
      // return this.section.id !== 'section_general' && shouldShow;
    },
    rows() {
      const rows = [];
      rows.push({
        className: 'row-border-top',
      }, {
        className: 'row-subsection-header',
        content: this.translate(this.section.titleLong),
        units: 'ui_assumptions_columns__units',
        zeroPeriod: '"0"',
      });
      return rows;
    },
  },
  methods: {
    selectAllSectionResources() {
      const someUnselected = this.section.sectionResources.some((resource) => !resource.isSelected);
      this.section.sectionResources.forEach((resource) => {
        // eslint-disable-next-line
        resource.isSelected = someUnselected;
      });
      // update store
      const { sections } = this.$store.state.activeTemplate.data;
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.sections',
        value: sections,
      });
    },
    // toggleEditingSettings() {
    //   this.toggleSectionEditingSettings(this.section);
    // },
  },
};
</script>
